export default "__VITE_ASSET__61eadc76__"